import {
  IonButton,
  IonContent,
  IonIcon,
  IonItem,
  IonList,
  IonListHeader,
  IonModal,
  IonPopover,
  IonText,
} from "@ionic/react";
import { ellipsisVerticalOutline, pencilOutline } from "ionicons/icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setShowMassiveSign } from "../../../store/documentsSignerList";
import { selectMassiveSign } from "../../../store/documentsSignerList/selectors/selectMassiveSign";
import { selectSegmentSelected } from "../../../store/documentsSignerList/selectors/selectSegmentSelected";

export const HelperActions: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const [popoverState, setShowPopover] = useState({
    showPopover: false,
    event: undefined,
  });
  const massiveSign = useSelector(selectMassiveSign);
  const segment = useSelector(selectSegmentSelected);

  return (
    <>
      {!massiveSign && segment === "pending" && (
        <>
          <IonButton onClick={() => setShowModal(true)} id="size-button">
            <IonText>Acciones</IonText>
            <IonIcon slot="end" icon={ellipsisVerticalOutline} />
          </IonButton>
          <IonModal
            isOpen={showModal}
            onDidDismiss={() => setShowModal(false)}
            cssClass={"modal-fix-popover"}
          >
            <IonContent>
              <IonList>
                <IonListHeader>
                  <h3>Acciones</h3>
                </IonListHeader>

                <IonItem
                  button
                  lines="none"
                  onClick={() => {
                    // setShowPopover({ showPopover: false, event: undefined });
                    setShowModal(false);
                    dispatch(setShowMassiveSign(true));
                  }}
                >
                  <IonIcon slot="start" icon={pencilOutline} />
                  <span>Firma masiva</span>
                </IonItem>
              </IonList>
            </IonContent>
          </IonModal>
          {/* <IonButton
            id="size-button"
            onClick={(e: any) => {
              e.persist();
              setShowPopover({ showPopover: true, event: e });
            }}
          >
            <IonText>Acciones</IonText>
            <IonIcon slot="end" icon={ellipsisVerticalOutline} />
          </IonButton>

          <IonPopover
            event={popoverState.event}
            isOpen={popoverState.showPopover}
            onDidDismiss={() => setShowPopover({ showPopover: false, event: undefined })}
          >
            <IonContent>
              <IonList>
                <IonListHeader>
                  <h3>Acciones</h3>
                </IonListHeader>

                <IonItem
                  button
                  lines="none"
                  onClick={() => {
                    setShowPopover({ showPopover: false, event: undefined });
                    dispatch(setShowMassiveSign(true));
                  }}
                >
                  <IonIcon slot="start" icon={pencilOutline} />
                  <span>Firma masiva</span>
                </IonItem>
              </IonList>
            </IonContent>
          </IonPopover> */}
        </>
      )}
    </>
  );
};
